import { mpfRListsHttp } from '../api/mpf-r-lists-http'

interface Discussion {
  Comment: string
  CommentDocumentName: string
  CommentType: string
  InquiryGUID: string
  InquiryId: number
  IsActionComment: boolean
  ItemCreated: string
  ItemCreatedBy: string
  ItemModified: string
  ItemModifiedBy: string
  Subject: string
  Title: string
  UserRole: string
  eKey: string
  eTag: string
}
interface DiscussionsFetchArgs {
  InquiryGUID: string
  refresh: boolean
}
interface Attachment {
  blobs: []
  itemKey: string
}
const LIST_NAME = 'InquiryDiscussionsList'
const COLUMN_NAMES = {
  Comment: 'Comment',
  CommentDocumentName: 'CommentDocumentName',
  CommentType: 'CommentType',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryGUID: 'InquiryGUID',
  InquiryID: 'InquiryID',
  IsActionComment: 'IsActionComment',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstName',
  ItemCreatedByLastName: 'ItemCreatedBy/lastName',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ParentCommentCode: 'ParentCommentCode',
  Subject: 'Subject',
  UserRole: 'UserRole',
  eKey: 'eKey',
  eTag: 'eTag',
}
const getDiscussions = async (args: DiscussionsFetchArgs): Promise<Discussion[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = `InquiryGUID eq '${args?.InquiryGUID}'`
  const items = await list
    .query()
    .select(
      COLUMN_NAMES.Comment,
      COLUMN_NAMES.Subject,
      COLUMN_NAMES.ItemCreatedByFirstName,
      COLUMN_NAMES.ItemCreatedByLastName,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.CommentType,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.CommentDocumentName,
      COLUMN_NAMES.ParentCommentCode,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.UserRole
    )
    .expand(COLUMN_NAMES.ItemCreatedBy)
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemCreated }])
    .filter(filter)
    .get()
  return [...items] as Discussion[]
}
export { type Attachment, type Discussion, type DiscussionsFetchArgs, LIST_NAME, getDiscussions }
